import React, { useState } from "react";
import { colors } from "../common/mixins";

interface InfoIconProps {
  color?: string;
  strokeColor?: string;
}

export const InfoIcon = ({
  color = colors.primary,
  strokeColor = "white",
}: InfoIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7328_81127)">
        <path
          d="M11.9998 5.39961C8.35471 5.39961 5.39979 8.35453 5.39979 11.9996C5.39979 15.6447 8.35471 18.5996 11.9998 18.5996C15.6449 18.5996 18.5998 15.6447 18.5998 11.9996C18.5998 8.35453 15.6449 5.39961 11.9998 5.39961Z"
          fill={color}
          stroke={color === "none" ? strokeColor : undefined}
          strokeWidth={color === "none" ? "1.2" : undefined}
        />
        <path
          d="M11.9998 15.1001L11.9998 11.5001"
          stroke={strokeColor}
          strokeWidth="1.2"
          strokeMiterlimit="round"
          strokeLinecap="round"
        />
        <path
          d="M12.0003 9.40039C11.8347 9.40039 11.6997 9.26609 11.6995 9.10059C11.6995 8.9349 11.8346 8.7998 12.0003 8.7998C12.1658 8.80002 12.3001 8.93503 12.3001 9.10059C12.2999 9.26596 12.1657 9.40018 12.0003 9.40039Z"
          fill={strokeColor}
          stroke={strokeColor}
          strokeWidth="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_7328_81127">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


